<template>
  <span class="ur-inline-wrap">
    <!-- 顯示態 -->
    <span
      v-if="!editing"
      class="ur-inline-display"
      :class="{ 'ur-inline-readonly': readonly }"
      @click="onDisplayClick"
    >{{ display !== undefined && display !== null ? display : (value === null || value === undefined ? '' : value) }}</span>

    <!-- 編輯態 -->
    <span v-else class="ur-inline-edit">
      <input
        ref="editInput"
        class="ur-inline-input"
        :type="type === 'text' ? 'text' : 'number'"
        v-model="draft"
        @keyup.enter="commit"
        @keyup.esc="cancel"
        @blur="cancel"
      />
      <button
        class="ur-inline-btn ur-inline-btn-confirm"
        tabindex="-1"
        @mousedown.prevent="commit"
        title="確認"
      >&#10003;</button>
      <button
        class="ur-inline-btn ur-inline-btn-cancel"
        tabindex="-1"
        @mousedown.prevent="cancel"
        title="取消"
      >&#10007;</button>
    </span>
  </span>
</template>

<script>
export default {
  name: 'UrbanRenewalInlineEdit',

  props: {
    value: {
      default: null,
    },
    type: {
      type: String,
      default: 'text',
      validator: (v) => ['text', 'int', 'float'].includes(v),
    },
    display: {
      default: undefined,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editing: false,
      draft: null,
    };
  },

  methods: {
    onDisplayClick() {
      if (this.readonly) return;
      // 有拖選文字時（滑鼠選取複製）不進入編輯，讓可選取的欄位能直接複製
      const sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;
      this.startEdit();
    },

    startEdit() {
      this.draft = this.value === null || this.value === undefined ? '' : String(this.value);
      this.editing = true;
      this.$nextTick(() => {
        if (this.$refs.editInput) {
          this.$refs.editInput.focus();
          this.$refs.editInput.select();
        }
      });
    },

    commit() {
      let val;
      if (this.type === 'text') {
        val = this.draft;
      } else if (this.type === 'int') {
        val = this.draft === '' ? null : parseInt(this.draft, 10);
      } else if (this.type === 'float') {
        val = this.draft === '' ? null : parseFloat(this.draft);
      } else {
        val = this.draft;
      }
      this.$emit('save', val);
      this.editing = false;
    },

    cancel() {
      this.editing = false;
    },
  },
};
</script>
